import type { Theme } from '@mui/material';

const baseCarouselStyle = (theme: Theme) => {
  const GAP = theme.spacing(2);

  return {
    '& .embla__container': {
      marginLeft: `calc(${GAP} * -1)`,
      display: 'flex',
    },
    '& .embla__viewport': {
      position: 'relative',
      '.embla__navigation-button': { display: 'none' },
      ':hover .embla__navigation-button': { display: 'flex' },
      '&:not(.is-touched) .embla__navigation-prev-button': { display: 'none' },
    },
    '& .embla__slide': {
      flex: '0 0 25%',
      paddingLeft: GAP,
      [theme.breakpoints.between('xs', 'sm')]: {
        flex: '0 0 85%',
      },
      [theme.breakpoints.between('sm', 'md')]: { flex: '0 0 45%' },
      [theme.breakpoints.between('md', 'lg')]: { flex: '0 0 30%' },
      [theme.breakpoints.between('lg', 'xl')]: { flex: '0 0 24%' },
      [theme.breakpoints.up('xl')]: { flex: '0 0 24%' },
    },
    '.embla__navigation-prev-button': {
      left: '1rem',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    '.embla__navigation-next-button': {
      right: '1rem',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  };
};
export { baseCarouselStyle };
